import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SirkaPneu = {
	name: NAME,
	apiProvider,
	router,
};
